import { css, useTheme } from "@emotion/react";
import { useState } from "react";
import NotebookOutline from "../../assets/notebook_outline.svg";
import { trpc } from "../../utils/trpc";
import { CollectionListItem } from "../bits/bookmarks/CollectionListItem";
import { CreateOrEditCollectionModal } from "../bits/bookmarks/CreateOrEditCollectionModal";
import { LoadingSpinner } from "../bits/loading";

export const CollectionsListPage = () => {
  const [openModal, setOpenModal] = useState<"create" | number | null>(null);
  const theme = useTheme();

  const { data: collectionsData, isLoading } = trpc.getCollections.useQuery();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <div
      css={css`
        display: grid;
        gap: 16px;
        grid-template-columns: repeat(auto-fill, 208px);
        justify-content: center;
        overflow: hidden;
      `}
    >
      {collectionsData?.map((collection) => (
        <CollectionListItem
          key={collection.id}
          collection={collection}
          colour={collection.colour}
        />
      ))}

      <div
        css={css`
          display: flex;
        `}
      >
        <CreateOrEditCollectionModal
          isOpen={openModal === "create"}
          onClose={() => setOpenModal(null)}
          renderButton={() => {
            return (
              <button
                css={css`
                  border: none;
                  background: none;
                  margin: 21px 0 0 14px;
                  position: relative;
                `}
                onClick={() => setOpenModal("create")}
                type="button"
              >
                <img src={NotebookOutline} alt="New Collection" />
                <div
                  css={css`
                    align-items: center;
                    display: flex;
                    height: 100%;
                    justify-content: center;
                    position: absolute;
                    top: 0;
                    width: 165px;
                  `}
                >
                  <span
                    css={css`
                      color: ${theme.colours.primary.dark._10};
                      ${theme.customTypography.jumbo._5}
                      width: 92px;
                    `}
                  >
                    + New Collection
                  </span>
                </div>
              </button>
            );
          }}
        />
      </div>
    </div>
  );
};
